export enum Days {
    MONDAY= 1,
    TUEASDAY,
    WEDNESDAY,
    THURSDAY,
    FRIDAY,
    SATURDAY,
    SUNDAY
}
